import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Table,
    Form,
    Dropdown,
    Modal,
    DropdownMenu,
    DropdownItem, Container, Input } from "reactstrap";
import { Link } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import avatar1 from "../../assets/images/users/avatar-1.jpg"
import SimpleBar from "simplebar-react";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

//Import Images
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import axios from 'axios';
import * as url from "../../helpers/url_helper"
import { HRConfig } from 'helpers/backend_helper';

    const Applications = () => {
        const [projects, setProjects] = useState([])
        const [username, setusername] = useState('')
        const [vacancies, setvacancies] = useState(0)
        const [applications, setapplications] = useState(0)
        const [isLoading, setIsLoading] = useState(false)
        const { SearchBar } = Search;

        const handleFilter = (e) => {
            e.preventDefault();
            let obj = JSON.parse(localStorage.getItem("authUser"));
            let EmployeeNo = obj.uid;
            let url = url.POSTED_LR;
            const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
            const startDate = formatDate(dateRange[0]);
            const endDate = formatDate(dateRange[1]);
            const stat = document.getElementsByClassName('filterStatus')[0].value;
            
            let urlParams = '';
        
            if(stat != ''){
              urlParams = urlParams.concat( ` and Status eq '${stat}' `);
            }
   
            if(dateRange.length > 0){
              urlParams = urlParams.concat(` and ( From_Date ge ${startDate} and To_Date le ${endDate} )`);
            }
            url += `?$filter=Employee_No eq '${EmployeeNo}'`
            if(urlParams != ''){
              url += urlParams;
            }
            axios.get(url, HRConfig).then(function(response){    setLeaveRequests(response.data.value);    })
        }

        const fetchProjects = () =>{
            setIsLoading(true)
            axios.get(url.RECRUITMENTPROJECTS, HRConfig).then((r)=>{
                console.log(r.data.value)
                setProjects(r.data.value)
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                setIsLoading(false)
            })
        }
        useEffect(() => {
            if (localStorage.getItem("authApplicant")) {
                const obj = JSON.parse(localStorage.getItem("authApplicant"))
                setusername(`${obj.fname} ${obj.lname}`)
                fetchProjects()
            }
          }, [])
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Applications | E-Recruitment</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="E-Recruitment" breadcrumbItem="Applications" />
                        <Row>
                            <Col lg="12">
                            <Card>
                                <CardBody>
                                    {projects && (
                                        <ToolkitProvider
                                        keyField="No"
                                        data={ projects }
                                        //columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className="mb-2">
                                                    <Col sm="12">
                                                        <div className="search-box me-2 mb-2 d-inline-block">
                                                        <div className="position-relative">
                                                            <SearchBar {...toolkitProps.searchProps} />
                                                            <i className="bx bx-search-alt search-icon" />
                                                        </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                            </Row>
                                            </React.Fragment>
                                            )}
                                        </ToolkitProvider>
                                    )}
                                </CardBody>
                                
                                
                                
                                {/*<CardBody>
                                 <Row>
                                    <Col lg="5">
                                    <div className="d-flex">
                                        <div className="me-3">
                                        <img
                                            src={avatar1}
                                            alt=""
                                            className="avatar-md rounded-circle img-thumbnail"
                                        />
                                        </div>
                                        <div className="flex-grow-1 align-self-center">
                                        <div className="text-muted">
                                            <p className="mb-2">Welcome to MILDMAY Job applications portal</p>
                                            <h5 className="mb-1">{username}</h5>
                                            <p className="mb-0">Applicant</p>
                                        </div>
                                        </div>
                                    </div>
                                    </Col>

                                    <Col lg="7" className="align-self-center">
                                    <div className="text-lg-center mt-4 mt-lg-0">
                                        <Row>
                                        <Col xs="6">
                                            <div>
                                            <p className="text-muted text-truncate mb-2">
                                                Vacancies
                                            </p>
                                            <h5 className="mb-0">{projects.length}</h5>
                                            </div>
                                        </Col>
                                        <Col xs="6">
                                            <div>
                                            <p className="text-muted text-truncate mb-2">
                                                Applications
                                            </p>
                                            <h5 className="mb-0">{applications}</h5>
                                            </div>
                                        </Col>
                                        
                                        </Row>
                                    </div>
                                    </Col>

                                    
                                </Row>
                                </CardBody> */}
                            </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4}>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">FILTER</h5>
                               <CardBody>
                                    <Form className="row gy-2 gx-3 align-items-center" onSubmit={handleFilter}>
                                        <Row>
                                        <Col lg={12}>
                                        <label htmlFor="autoSizingSelect">Job Title</label>
                                        <div className="col-sm-auto">
                                        <Input
                                            name="jobTitle"
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter Job Title"
                                            />
                                        </div>
                                        </Col>
                                        <Col lg={12}>
                                        <label htmlFor="autoSizingSelect">Location</label>
                                        <div className="col-sm-auto">
                                        <Input
                                            name="location"
                                            className="form-control"
                                            type="text"
                                            placeholder="Enter Location"
                                            />
                                        </div>
                                        </Col>
                                        <></>
                                        <Col lg={12}>
                                        <div className="hstack gap-2">
                                            <button type="submit" className="btn btn-primary btn-label">
                                            <i className="bx bx-filter label-icon"></i>
                                            Find jobs
                                            </button>
                                        </div>
                                        </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">JOB TYPE</h5>
                                <CardBody>
                                    <CardTitle className="mB-5"></CardTitle>
                                        <Form className="row gy-2 gx-3 align-items-center" onSubmit={handleFilter}>
                                        <Row>
                                            <Col lg={3}>
                                            <div className="col-sm-auto" placeholder="Job Title">
                                            </div>
                                            </Col>
                                        </Row>
                                    </Form>
                              
                                    <div className="text-center mt-4">
                                    
                                    </div>
                                    </CardBody>
                                </Card>
                                <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">DEPARTMENT</h5>
                                <CardBody>
                                    <CardTitle className="mB-5"></CardTitle>
                                        <Form className="row gy-2 gx-3 align-items-center" onSubmit={handleFilter}>
                                        <Row>
                                            <Col lg={3}>
                                            <div className="col-sm-auto" placeholder="Job Title">
                                            </div>
                                            </Col>
                                        </Row>
                                    </Form>
                              
                                    <div className="text-center mt-4">
                                    
                                    </div>
                                    </CardBody>
                                </Card>
                            
                            </Col>
                            <Col xl="8">
                                <Card>
                                <h5 className="card-header bg-transparent border-bottom text-uppercase text-primary">Vacancies</h5>
                                <CardBody>
                                    <h4 className="card-title mb-4"></h4>
                                    <SimpleBar style={{ maxHeight: "310px" }}>
                                    <ul className="list-group">

                                    {(projects.length > 0) ? (
                                    <Table  className="table table-striped table-sm mb-4">
                                    {projects.map((p,k)=>(
                                        <li key={k} className="list-group-item border-0">
                                        <div className="d-flex">
                                            <div className="avatar-xs me-3">
                                            <span className="avatar-title rounded-circle bg-light">
                                                <img src={img1} alt="" height="18" />
                                            </span>
                                            </div>
                                            <div className="flex-grow-1">
                                            <h5 className="font-size-14">{p.PositionDescription} ({p.QuantityRequested})</h5>
                                            <p className="text-muted">
                                                {p.positionSummary}
                                            </p>

                                            <div className="float-end">
                                                <p className="text-muted mb-0">
                                                <Link to={`/vacancy-details/${p.SystemId}`}>...more details</Link>
                                                </p>
                                            </div>
                                            <p className="text-muted mb-0">Deadline: {p.applicationSubmissionDeadline}</p>
                                            </div>
                                        </div>
                                        </li>
                                        ))}
                                        </Table>
                                    ):(
                                        <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-home-search-outline text-warning display-4" />
                                        </div>
                                        <div>
                                        <h5>No Vacancies available yet!!!</h5>
                                        <p className="text-muted">
                                                
                                        </p>
                                        </div>
                                    </div>
                                    )}
                                        
                                    </ul>
                                    </SimpleBar>
                                </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        );
    }

export default Applications;